import axios from 'axios'
import { showToast } from 'vant'
import router from '@/router'

export const ajax = axios.create({
    baseURL: "http://www.rosos.com.cn:8080/",
})
/**
 *
 * 请求拦截器
 */
ajax.interceptors.request.use(

)
/**
 *
 * 响应拦截器
 */
ajax.interceptors.response.use(

)
